import { ChangeDetectionStrategy, Component } from "@angular/core";

@Component({
  selector: "separated-by-type",
  styleUrls: ["separated-by-type.component.scss"],
  templateUrl: "separated-by-type.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SeparatedByTypeComponent {}
